import { formatMoneda } from './varios';


export const verificarSeleccion = (index, chkSeleccionar, tabDeu, idContribuyente) => {
	var n = 0, pos = 0, poschk = -1;
	var nn = 0;
	var montoseleccionado = 0.0;
	var montoFacturadoSelect = 0.0;
	var interesesSelect = 0.0;
	var multaSelect = 0.0;
	var recargoSelect = 0.0;
	var retenSelect = 0.0;
	var acrediSelect = 0.0;
	var per = "";
	var periodofac = "";
	var continua = true;
	var seleccionados = 0;

	for (let i = 0; i < chkSeleccionar.current.length; i++) {
		
		if (chkSeleccionar.current[i].checked === true) {
			pos = i;
			n = n + 1;
			if (pos > poschk & poschk > -1) {

				continua = false;

				n = 0;
				pos = -1;
				poschk = 0;
				if (n === 0) {
					chkSeleccionar.current[index].checked = false;
				}
			}


		} else if (chkSeleccionar.current[i].checked === false) {

			if (tabDeu[i].status === 'Por Pagar') {
				poschk = i;
			}
		}
	}

	if (continua || index > 0) {

		per = "Periodo(s) de Pago: ";

		for (let x = 0; x <= index; x++) {

			if (chkSeleccionar.current[x].checked && tabDeu[x].status !== 'Verificando Pago') {
				periodofac = periodofac + tabDeu[x].nummes + ' / ' + tabDeu[x].anio + ' ';
				if (tabDeu[x].tipodeuda === 11 || tabDeu[x].tipodeuda === 22 || tabDeu[x].tipodeuda === 33 || tabDeu[x].tipodeuda === 44) {
					per = per + "Multa " + (tabDeu[x].nummes.length === 2 ? tabDeu[x].mes : 'DEFINITIVA') + ' / ' + tabDeu[x].anio + ' ';
				} else {
					per = per + (tabDeu[x].nummes.length === 2 ? tabDeu[x].mes : 'DEFINITIVA') + ' / ' + tabDeu[x].anio + ' ';
				}

				seleccionados++;
				montoseleccionado = parseFloat(montoseleccionado) + parseFloat(tabDeu[x].totalperi);
				montoseleccionado = Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
				acrediSelect = parseFloat(acrediSelect) + parseFloat(tabDeu[x].credito);
				acrediSelect = Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
				montoFacturadoSelect = parseFloat(montoFacturadoSelect) + parseFloat(tabDeu[x].monto);
				montoFacturadoSelect = Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
				interesesSelect = parseFloat(interesesSelect) + parseFloat(tabDeu[x].intereses);
				interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
				multaSelect = parseFloat(multaSelect) + parseFloat(tabDeu[x].multa);
				multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
				recargoSelect = parseFloat(recargoSelect) + parseFloat(tabDeu[x].recargo);
				recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
				retenSelect = parseFloat(retenSelect) + parseFloat(tabDeu[x].retenciones);
				retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			}
		}
	} else {

	}

	var resulta = [];
	resulta.push({
		continua: continua,
		concepto: per,
		montoseleccionado: formatMoneda(montoseleccionado.toString().replace('.', ','), ',', '.', 2),
		seleccionados: seleccionados,
		acrediSelect: formatMoneda(acrediSelect.toString().replace('.', ','), ',', '.', 2),
		montoFacturadoSelect: formatMoneda(montoFacturadoSelect.toString().replace('.', ','), ',', '.', 2),
		interesesSelect: formatMoneda(interesesSelect.toString().replace('.', ','), ',', '.', 2),
		multaSelect: formatMoneda(multaSelect.toString().replace('.', ','), ',', '.', 2),
		recargoSelect: formatMoneda(recargoSelect.toString().replace('.', ','), ',', '.', 2),
		retenSelect: formatMoneda(retenSelect.toString().replace('.', ','), ',', '.', 2),

	});
	return resulta;

}

export const verificarSeleccionP = (index, chkSeleccionar, tabDeu, tabla) => {
	/* var n = 0, pos = 0, poschk = -1; */
	var montoseleccionado = 0.0;
	var montoFacturadoSelect = 0.0;
	var interesesSelect = 0.0;
	var multaSelect = 0.0;
	var recargoSelect = 0.0;
	var retenSelect = 0.0;
	var acrediSelect = 0.0;
	/*var periodo = "";*/
	var per = "";
	var periodofac = "";
	var continua = true;
	var seleccionados = 0;


	for (let x = 0; x < chkSeleccionar.current.length; x++) {

		if (chkSeleccionar.current[x].checked) {
			periodofac = periodofac + tabDeu[x].nummes + ' / ' + tabDeu[x].anio + ' ';
			per = (per === '' ? '' : per + ', ') + (tabDeu[x].descripcion) + ' periodo ' + tabDeu[x].anio;
			seleccionados++;
			montoseleccionado = parseFloat(montoseleccionado) + parseFloat(tabDeu[x].totalperi);
			montoseleccionado = Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
			acrediSelect = parseFloat(acrediSelect) + parseFloat(tabDeu[x].credito);
			acrediSelect = Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			montoFacturadoSelect = parseFloat(montoFacturadoSelect) + parseFloat(tabDeu[x].monto);
			montoFacturadoSelect = Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			interesesSelect = parseFloat(interesesSelect) + parseFloat(tabDeu[x].intereses);
			interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			multaSelect = parseFloat(multaSelect) + parseFloat(tabDeu[x].multa);
			multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			recargoSelect = parseFloat(recargoSelect) + parseFloat(tabDeu[x].recargo);
			recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
			retenSelect = parseFloat(retenSelect) + parseFloat(tabDeu[x].retenciones);
			retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
		}
	}

	var resulta = [];
	resulta.push({
		continua: continua,
		concepto: (per === '' ? '' : tabla === 'publicidad' ? "Pago de Publicidad " : "Pago de Renta de Licores ") + per,
		montoseleccionado: formatMoneda(montoseleccionado.toString().replace('.', ','), ',', '.', 2),
		seleccionados: seleccionados,
		acrediSelect: formatMoneda(acrediSelect.toString().replace('.', ','), ',', '.', 2),
		montoFacturadoSelect: formatMoneda(montoFacturadoSelect.toString().replace('.', ','), ',', '.', 2),
		interesesSelect: formatMoneda(interesesSelect.toString().replace('.', ','), ',', '.', 2),
		multaSelect: formatMoneda(multaSelect.toString().replace('.', ','), ',', '.', 2),
		recargoSelect: formatMoneda(recargoSelect.toString().replace('.', ','), ',', '.', 2),
		retenSelect: formatMoneda(retenSelect.toString().replace('.', ','), ',', '.', 2),

	});
	return resulta;

}

